import React from 'react';
import './Footer.css';
import { isInTeams } from '../common/Teams';
import { isInShell } from '../common/Shell';

const Footer: React.FC = () => {
    const inTeams = isInTeams();
    const inShell = isInShell();
    let year = new Date().getFullYear();

    return (
        <>
            {(!inTeams && !inShell) ? (
                <footer className="footer">
                    <div className="footer-content">
                        <div className="footer-copyright">
                            © Kantar Group and Affiliates {year}
                        </div>
                        <div className="footer-links">
                            <a target='_blank' href="https://marketplacesupport.kantar.com/support/tickets/new" className="footer-link">Contact Us</a>
                            <a target='_blank' href="https://marketplacesupport.kantar.com/support/home" className="footer-link">FAQs</a>
                            <a target='_blank' href="https://www.kantar.com/cookies-policies" className="footer-link">Privacy Policy</a>
                            <a target='_blank' href="https://www.kantar.com/marketplace/terms-and-use" className="footer-link">Terms of Use</a>
                        </div>
                    </div>
                </footer>
            ) : null}
        </>
    );
};

export default Footer;
